module.exports = __webpack_public_path__ + "static/media/defaultBcg.aebaec51.jpeg";